import React, { memo, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CardViewX, ButtonMenu } from '@ann/web-components';
import {DriveCardContainer} from "../Drives.styled";

// ✅ PERFORMANCE: Memoized component prevents unnecessary re-renders
const DriveCard = memo(({ 
  drive,
  isSelected,
  onCheckboxChange,
  onMenuChange,
  dateLabel,
  dateTooltip
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const isCheckboxVisible = isHovered || isSelected;

  // ✅ Handle double click to navigate to drive workspace
  const handleDoubleClick = useCallback(() => {
    if (drive.id) {
      navigate(`/v2/drives/d/${drive.id}`);
    }
  }, [drive.id, navigate]);

  return (
    <DriveCardContainer id="drive-card" onDoubleClick={handleDoubleClick}>
        <CardViewX
            checked={isSelected}
            isCheckboxable={isCheckboxVisible}
            onCheckboxChange={onCheckboxChange}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            showHover
            size="medium"
        >
            <CardViewX.Header
                icon="hardDrive2"
                maxCharacters={isCheckboxVisible ? 18 : 21}
                title={drive.title}
                menu={(
                    <ButtonMenu
                        customIcon="dotsMenu"
                        disableEffects
                        menuPosition="bottom"
                        onChange={onMenuChange}
                        size="medium"
                        type="tertiary"
                        width="180px"
                        className="dots-menu"
                    >
                        <ButtonMenu.Menu icon>
                            <ButtonMenu.Item
                                label="Rename"
                                value="rename"
                                icon="edit"
                            />
                        </ButtonMenu.Menu>
                    </ButtonMenu>
                )}
            />
            {/* <CardViewX.Meta>
                <CardViewX.MetaItem
                    icon="lastUpdated"
                    label={dateLabel}
                    tooltipContent={dateTooltip}
                />
                <CardViewX.MetaItem
                    icon="folder"
                    label={drive.folderCount}
                    tooltipContent="File size"
                />
            </CardViewX.Meta> */}
        </CardViewX>
    </DriveCardContainer>
);
});

DriveCard.displayName = 'DriveCard';

export default DriveCard;
